import {interpret} from 'xstate';

import {machine} from '$lib/machines/auth';

const authService = interpret(machine, {devTools: true}).start();

export {authService};
